import { render, staticRenderFns } from "./modal-primary-method.vue?vue&type=template&id=072504e4&"
import script from "./modal-primary-method.vue?vue&type=script&lang=js&"
export * from "./modal-primary-method.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports